import { useContext } from 'react';
import { Paper } from '@safedns/skydns-ui-react-lib';

import AuthContext from '../../contexts/authContext';

import AuthKey from './AuthKey';
import CreateDomain from './CreateDomain';
import ConfigurateAd from './ConfigurateAd';
import DomainsList from './DomainsList';
import DomainControllers from '../domainControllers/DomainControllers';
import styles from './Domains.module.scss';

const Domains = () => {
  const { availableFeatures } = useContext(AuthContext);

  const { areLocalDomainsAvailable } = availableFeatures;

  return (
    <div className={styles.container}>
      <AuthKey />
      <ConfigurateAd />
      <Paper title="Создать домен">
        <CreateDomain />
        <DomainsList />
      </Paper>
      {areLocalDomainsAvailable ? <DomainControllers /> : null}
    </div>
  );
};


export default Domains;
